import SEO from "@/components/SEO";

export default function AboutPage() {
  return (
    <div>
      <SEO title="About" description="Choose My Hotel is an independent editorial comparison service for American hotels — affiliate-funded, never paid placement." />
      <section className="bg-cream border-b border-charcoal/5">
        <div className="container-x py-16 md:py-24 max-w-4xl">
          <div className="overline text-terracotta">About Choose My Hotel</div>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl leading-[1.02] tracking-tight">
            We read every hotel website so you don't have to.
          </h1>
        </div>
      </section>

      <section className="container-x py-16 max-w-3xl space-y-8 text-lg leading-relaxed text-charcoal/80">
        <p>Choose My Hotel is an independent editorial comparison service focused entirely on the American hotel market. We cover the eight operators that matter most to US travelers — Booking.com, Hotels.com, Marriott Bonvoy, Hilton Honors, Choice Hotels, IHG One Rewards, World of Hyatt, and Wyndham Rewards.</p>
        <p>Our work is simple: we test real itineraries, compare real prices, and write in plain English about which rooms are worth the money and which aren't. We don't take paid placements. A property's rank is never for sale.</p>
        <p>Some outbound links on this site are affiliate partnerships. When you book through them, we may receive a small commission — at no cost to you, and with no influence on our rankings. That's how we keep the comparator free and the editorial independent.</p>
        <p>Questions, corrections, or a hotel we should review? Write to us at <a className="text-terracotta underline" href="mailto:hello@choose-my-hotel.com">hello@choose-my-hotel.com</a>.</p>
      </section>
    </div>
  );
}
